module.exports = __webpack_public_path__ + "img/instagram-icon.149553fd.svg";